/**
 * Created by Vladislav on 19.02.2026.
 */

const KnockoutVictoryAction = function (f) {
    if (cleverapps.isKnockoutGame() && this.level.isRegular()) {
        const rumble = cleverapps.knockoutGame.rumble;

        if (rumble.outcome !== Rumble.OUTCOME_UNKNOWN) {
            const actions = [];

            if (rumble.outcome === Rumble.OUTCOME_WIN) {
                actions.push((f) => {
                    cleverapps.knockoutGame.openWindow(f);
                });

                actions.push((f) => {
                    new KnockoutVictoryWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                });
            }

            actions.push((f) => {
                cleverapps.knockoutGame.stopRumble();

                f();
            });

            cleverapps.focusManager.compound(f, actions);
            return;
        }
    }

    f();
};